import React from 'react'
import {
    Edit,
    SimpleForm,
    TextInput,
    NumberInput,
} from 'react-admin'


export const SistemaInterconectadoEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <NumberInput source="id" disabled={true}/>
            <TextInput source="name" />
            <TextInput source="code" />
        </SimpleForm>
    </Edit>
);
